import Publisher from 'Utils/api/publisher';
import {
  toastShowErrorAction,
  toastShowInfoAction,
} from '../actions/toast-actions';
import { PUBLISHER_TYPES } from 'Webapp/action-types';
import { currentUser } from 'Webapp/shared/app/redux/selectors/profile';

export const fetchPublisherInfo = (uid) =>
  async function (dispatch) {
    try {
      const params = { uid };
      dispatch({ type: PUBLISHER_TYPES.GET_PUBLISHER_INFO_PENDING });
      const { data } = await Publisher.get('/v1/publisher_by_uid', {
        params,
      });
      const publisher =
        Object.keys(data.publisher).length > 0 ? data.publisher : null;
      dispatch({
        type: PUBLISHER_TYPES.GET_PUBLISHER_INFO_SUCCESS,
        publisher,
      });
    } catch (error) {
      dispatch({ type: PUBLISHER_TYPES.GET_PUBLISHER_INFO_FAILED });
    }
  };

export const fetchPipes = (uid) =>
  async function (dispatch) {
    try {
      const params = { account_id: uid };
      dispatch({ type: PUBLISHER_TYPES.GET_PUBLISHER_PIPES_PENDING });
      const { data } = await Publisher.get('/v1/pipes', {
        params,
      });
      dispatch({
        type: PUBLISHER_TYPES.GET_PUBLISHER_PIPES_SUCCESS,
        pipes: data.pipes || [],
      });
    } catch (error) {
      dispatch({ type: PUBLISHER_TYPES.GET_PUBLISHER_PIPES_FAILED });
    }
  };

export const setStatusPending = (id) =>
  async function (dispatch) {
    try {
      dispatch({ type: PUBLISHER_TYPES.UPDATE_PUBLISHER_STATUS_PENDING });
      const today = new Date();
      const onboardDate = `${today.getFullYear()}-${
        today.getMonth() + 1
      }-${today.getDate()} ${today.getHours()}:${today.getMinutes()}:${today.getSeconds()}`;
      const { data } = await Publisher.put(`/v1/publisher_pending/${id}`, {
        data: {
          onboarding_status: 'pending',
          onboard_date: onboardDate,
        },
      });
      dispatch({
        type: PUBLISHER_TYPES.UPDATE_PUBLISHER_STATUS_SUCCESS,
        publisher: data.publisher,
      });
    } catch (error) {
      dispatch({ type: PUBLISHER_TYPES.UPDATE_PUBLISHER_STATUS_FAILED });
    }
  };

export const setPaywall = (id) =>
  async function (dispatch) {
    try {
      dispatch({ type: PUBLISHER_TYPES.UPDATE_PUBLISHER_PAYWALL });
      const { data } = await Publisher.put(
        `/v1/publisher_indicated_paywall/${id}`,
      );
      dispatch({
        type: PUBLISHER_TYPES.UPDATE_PUBLISHER_PAYWALL_SUCCESS,
        publisher: data.publisher,
      });
    } catch (error) {
      dispatch({ type: PUBLISHER_TYPES.UPDATE_PUBLISHER_PAYWALL_FAILED });
    }
  };

export const createPublisher = (uid, username) =>
  async function (dispatch, _, { t }) {
    try {
      dispatch({ type: PUBLISHER_TYPES.CREATE_PUBLISHER_PENDING });
      const body = {
        account_id: uid,
        data: {
          username,
          onboarding_status: 'incomplete',
        },
      };
      const response = await Publisher.post('/v1/publisher_create', body);
      const publisher = response.data && response.data.publisher;
      dispatch({
        type: PUBLISHER_TYPES.CREATE_PUBLISHER_SUCCESS,
        publisher,
      });
      return publisher;
    } catch (error) {
      dispatch({ type: PUBLISHER_TYPES.CREATE_PUBLISHER_FAILED });
      dispatch(toastShowErrorAction(t('fallback_error_message')));
    }
  };

export const cancelPublisherApplication = (uid) =>
  async function (dispatch, _, { t }) {
    try {
      dispatch({ type: PUBLISHER_TYPES.CANCEL_PUBLISHER_APPLICATION_PENDING });
      const params = { uid };
      const { data } = await Publisher.get(`/v1/publisher_optout`, {
        params,
      });
      dispatch({
        type: PUBLISHER_TYPES.CANCEL_PUBLISHER_APPLICATION_SUCCESS,
        publisher: data.publisher,
      });
      dispatch(toastShowInfoAction(t('cancel_publisher_application_success')));
    } catch (error) {
      dispatch({ type: PUBLISHER_TYPES.CANCEL_PUBLISHER_APPLICATION_FAILED });
      dispatch(toastShowErrorAction(t('fallback_error_message')));
    }
  };

export const ensureUserPublisher = () => async (dispatch, getState) => {
  const {
    publisher: { publisherInfo: alreadyLoadedPublisherInfo },
    auth: { uid },
  } = getState();
  // if we already have loaded publisher info, we don't need to do
  // anything else
  if (alreadyLoadedPublisherInfo?.name) {
    return;
  }
  // attempt to load publisher info
  await dispatch(fetchPublisherInfo(uid));
  const {
    publisher: { publisherInfo: loadedPublisherInfo },
  } = getState();
  // if we have publisher info now we can bail
  if (loadedPublisherInfo?.name) {
    return;
  }
  // if we still have no publisher info, we try to create
  const user = currentUser(getState());
  await dispatch(createPublisher(uid, user.screenname));
};
